import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover.tsx'
import { classNames } from '@/utils/helpers.ts'

export const months = {
  January: 31,
  February: 29,
  March: 31,
  April: 30,
  May: 31,
  June: 30,
  July: 31,
  August: 31,
  September: 30,
  October: 31,
  November: 30,
  December: 31,
} as const

export type Month = keyof typeof months
export const monthKeys = Object.keys(months) as Month[] // as satisfied by the above type

export interface MonthSelectorProps {
  value: Month | null
  onChange: (value: Month) => void
}

export const MonthSelector = (props: MonthSelectorProps) => {
  const { value, onChange } = props

  return (
    <Popover>
      <PopoverTrigger className="w-[160px]">
        <div className="col-span-12 sm:col-span-6 group relative text-sm flex items-center gap-2 bg-card border rounded-md px-3 py-2 w-full truncate focus-within:border-primary-500 dark:hover:bg-secondary-600">
          {value ? (
            value
          ) : (
            <span className="text-secondary-300">Select the Month</span>
          )}
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="p-6 rounded-lg shadow-2xl z-[102] max-w-[300px] select-auto border"
      >
        <div className="grid grid-cols-2 gap-2">
          {monthKeys.map((month) => (
            <button
              key={month}
              className={classNames(
                'col-span-1 py-2 text-sm font-medium bg-secondary-50 dark:bg-secondary-500/40 rounded-md cursor-pointer transition ease-out duration-300',
                {
                  'bg-primary-500 dark:bg-primary-500 text-white':
                    month === value,
                  'hover:bg-secondary-100 dark:hover:bg-secondary-500/60':
                    month !== value,
                },
              )}
              onClick={() => onChange(month)}
            >
              {month}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
